import { render, staticRenderFns } from "./KPMGRPODashboard.vue?vue&type=template&id=6ff50406&scoped=true&"
import script from "./KPMGRPODashboard.vue?vue&type=script&lang=js&"
export * from "./KPMGRPODashboard.vue?vue&type=script&lang=js&"
import style0 from "./KPMGRPODashboard.vue?vue&type=style&index=0&id=6ff50406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff50406",
  null
  
)

export default component.exports